import { axios, URL_BASE } from "./_shared";

// ============================================
// FLEET MANAGEMENT
// ============================================
export const getFleetVehicles = (params = {}) => {
  return axios.get(`${URL_BASE}fleet/vehicles`, { params });
};

export const getFleetVehicleById = (id) => {
  return axios.get(`${URL_BASE}fleet/vehicles/${id}`);
};

export const createFleetVehicle = (data) => {
  return axios.post(`${URL_BASE}fleet/vehicles`, data);
};

export const updateFleetVehicle = (id, data) => {
  return axios.put(`${URL_BASE}fleet/vehicles/${id}`, data);
};

export const deleteFleetVehicle = (id, observation = "") => {
  return axios.delete(`${URL_BASE}fleet/vehicles/${id}`, {
    data: { observation }
  });
};

export const permanentDeleteFleetVehicle = (id) => {
  return axios.delete(`${URL_BASE}fleet/vehicles/${id}/permanent`);
};

export const reactivateFleetVehicle = (id) => {
  return axios.put(`${URL_BASE}fleet/vehicles/${id}/reactivate`);
};

export const getFleetDashboard = () => {
  return axios.get(`${URL_BASE}fleet/dashboard/summary`);
};

export const getFleetAlerts = (days = 30) => {
  return axios.get(`${URL_BASE}fleet/dashboard/alerts`, { params: { days } });
};

export const getFleetStats = () => {
  return axios.get(`${URL_BASE}fleet/dashboard/stats`);
};

export const getVehicleInsurance = (vehicleId) => {
  return axios.get(`${URL_BASE}fleet/insurance/vehicle/${vehicleId}`);
};

export const createVehicleInsurance = (vehicleId, data) => {
  return axios.post(`${URL_BASE}fleet/insurance/vehicle/${vehicleId}`, data);
};

export const updateVehicleInsurance = (id, data) => {
  return axios.put(`${URL_BASE}fleet/insurance/${id}`, data);
};

export const deleteVehicleInsurance = (id) => {
  return axios.delete(`${URL_BASE}fleet/insurance/${id}`);
};

export const getVehicleVtv = (vehicleId) => {
  return axios.get(`${URL_BASE}fleet/vtv/vehicle/${vehicleId}`);
};

export const createVehicleVtv = (vehicleId, data) => {
  return axios.post(`${URL_BASE}fleet/vtv/vehicle/${vehicleId}`, data);
};

export const getVehicleMaintenance = (vehicleId) => {
  return axios.get(`${URL_BASE}fleet/maintenance/vehicle/${vehicleId}`);
};

export const createVehicleMaintenance = (vehicleId, data) => {
  return axios.post(`${URL_BASE}fleet/maintenance/vehicle/${vehicleId}`, data);
};

export const getAllFleetIncidents = (params = {}) => {
  return axios.get(`${URL_BASE}fleet/incidents`, { params });
};

export const getVehicleIncidents = (vehicleId) => {
  return axios.get(`${URL_BASE}fleet/incidents/vehicle/${vehicleId}`);
};

export const createVehicleIncident = (vehicleId, data) => {
  return axios.post(`${URL_BASE}fleet/incidents/vehicle/${vehicleId}`, data);
};

export const updateVehicleIncident = (id, data) => {
  return axios.put(`${URL_BASE}fleet/incidents/${id}`, data);
};

export const deleteVehicleIncident = (id) => {
  return axios.delete(`${URL_BASE}fleet/incidents/${id}`);
};

export const getVehicleDrivers = (vehicleId) => {
  return axios.get(`${URL_BASE}fleet/vehicles/${vehicleId}/drivers`);
};

export const assignVehicleDriver = (vehicleId, employeeId) => {
  return axios.post(`${URL_BASE}fleet/vehicles/${vehicleId}/drivers/${employeeId}`);
};

export const unassignVehicleDriver = (vehicleId, employeeId) => {
  return axios.delete(`${URL_BASE}fleet/vehicles/${vehicleId}/drivers/${employeeId}`);
};

export const validateFleetImport = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(`${URL_BASE}fleet/vehicles/import/validate`, formData);
};

export const confirmFleetImport = (validationId) => {
  return axios.post(`${URL_BASE}fleet/vehicles/import/confirm/${validationId}`);
};

// ============ Fleet Authorizations ============
export const getFleetAuthorizations = () => {
  return axios.get(`${URL_BASE}fleet/authorizations`);
};

export const checkMyFleetAuthorization = () => {
  return axios.get(`${URL_BASE}fleet/authorizations/me`);
};

export const checkMyAuthorizations = () => {
  return axios.get(`${URL_BASE}api/authorizations/me`);
};

export const grantFleetAuthorization = (employeeId, scope = "FULL") => {
  return axios.post(`${URL_BASE}fleet/authorizations/${employeeId}?scope=${scope}`);
};

export const updateFleetAuthorizationScope = (employeeId, scope) => {
  return axios.put(`${URL_BASE}fleet/authorizations/${employeeId}/scope?scope=${scope}`);
};

export const revokeFleetAuthorization = (employeeId) => {
  return axios.delete(`${URL_BASE}fleet/authorizations/${employeeId}`);
};

// Mi Vehiculo (employee's assigned vehicle)
export const getMyVehicle = () => {
  return axios.get(`${URL_BASE}fleet/my-vehicle`);
};

export const updateMyVehicle = (data) => {
  return axios.put(`${URL_BASE}fleet/my-vehicle`, data);
};

export const addMyVehicleVtv = (data) => {
  return axios.post(`${URL_BASE}fleet/my-vehicle/vtv`, data);
};

export const addMyVehicleInsurance = (data) => {
  return axios.post(`${URL_BASE}fleet/my-vehicle/insurance`, data);
};

export const addMyVehicleMaintenance = (data) => {
  return axios.post(`${URL_BASE}fleet/my-vehicle/maintenance`, data);
};

export const updateMyVehicleVtv = (id, data) => {
  return axios.put(`${URL_BASE}fleet/my-vehicle/vtv/${id}`, data);
};

export const updateMyVehicleInsurance = (id, data) => {
  return axios.put(`${URL_BASE}fleet/my-vehicle/insurance/${id}`, data);
};

export const addMyVehicleIncident = (data) => {
  return axios.post(`${URL_BASE}fleet/my-vehicle/incident`, data);
};
